import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

function getReport(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/weekly-reports-report`, options).then((response) => {
    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  });
}

function getChartData(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/weekly-reports-chart-data`, options).then((response) => {
    return response.data.data;
  });
}

export default {
  getReport,
  getChartData,
};
